import type {
  FeatureRequestStatus,
  FeatureRequestType,
} from "@/infrastructure/supabase/database.types";

export const REQUEST_TYPES: { value: FeatureRequestType; label: string }[] = [
  { value: "feature", label: "Feature" },
  { value: "feedback", label: "Feedback" },
  { value: "issue", label: "Issue" },
  { value: "other", label: "Other" },
];

export const REQUEST_STATUSES: { value: FeatureRequestStatus; label: string }[] = [
  { value: "new", label: "New" },
  { value: "triaged", label: "Triaged" },
  { value: "planned", label: "Planned" },
  { value: "in-progress", label: "In progress" },
  { value: "done", label: "Done" },
  { value: "declined", label: "Declined" },
];

export const REQUEST_TYPE_LABEL: Record<FeatureRequestType, string> = Object.fromEntries(
  REQUEST_TYPES.map((t) => [t.value, t.label])
) as Record<FeatureRequestType, string>;

export const REQUEST_STATUS_LABEL: Record<FeatureRequestStatus, string> = Object.fromEntries(
  REQUEST_STATUSES.map((s) => [s.value, s.label])
) as Record<FeatureRequestStatus, string>;

export const REQUEST_TYPE_TONE: Record<FeatureRequestType, string> = {
  feature: "var(--primary)",
  feedback: "oklch(0.72 0.1 208)",
  issue: "var(--rag-red)",
  other: "var(--muted-foreground)",
};

// A plain-text scaffold that pre-fills the description per type, nudging authors
// to give structured, actionable feedback rather than a one-liner. Rendered as
// whitespace-pre-wrap (no markdown), so these are plain section prompts.
export const REQUEST_DESCRIPTION_TEMPLATES: Record<FeatureRequestType, string> = {
  feature: [
    "What would you like to be able to do?",
    "",
    "Why it matters / the problem it solves:",
    "",
    "Where in the app (if relevant):",
    "",
  ].join("\n"),
  issue: [
    "What happened?",
    "",
    "What did you expect instead?",
    "",
    "Where (page / screen) + steps to reproduce:",
    "",
  ].join("\n"),
  feedback: ["What's your feedback?", "", "Context, examples, or a suggestion:", ""].join("\n"),
  other: ["What would you like us to address?", "", "Any context:", ""].join("\n"),
};
